import prefill from './prefill';

export default prefill({
  slim: {},
  broad: {},
});
